// frontend/src/config.js
export const API_URL = 'https://kaizjen-backend.3f6m6r9kr2wv0.ap-northeast-1.cs.amazonlightsail.com';

// API Endpoints
export const API_ENDPOINTS = {
  VOCABULARY: {
    LIST: '/api/vocabulary',
    ADD: '/api/vocabulary/add',
    DELETE: '/api/vocabulary/delete',
  },
  GRAMMAR: {
    CHECK: '/api/grammar/check',
    TTS: '/api/tts/synthesize',
  },
  DICTIONARY: {
    SEARCH: '/api/dictionary/search',
  },
  TRANSLATE: {
    TEXT: '/api/translate',
  },
};